var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.164 15.902L16.4536 27.5L4.74323 15.902C3.97082 15.1504 3.36241 14.247 2.9563 13.2487C2.55019 12.2503 2.35519 11.1787 2.38357 10.1014C2.41195 9.02398 2.66309 7.96414 3.1212 6.98859C3.5793 6.01303 4.23443 5.1429 5.04534 4.43298C5.85625 3.72305 6.80536 3.18872 7.83292 2.86363C8.86048 2.53854 9.94422 2.42972 11.0159 2.54404C12.0876 2.65837 13.124 2.99334 14.0598 3.52788C14.9957 4.06242 15.8107 4.78495 16.4536 5.64995C17.0993 4.79123 17.9153 4.07501 18.8505 3.54615C19.7857 3.01728 20.82 2.68714 21.8887 2.57639C22.9574 2.46565 24.0374 2.57667 25.0612 2.90252C26.085 3.22838 27.0305 3.76204 27.8386 4.47011C28.6466 5.17819 29.2998 6.04543 29.7573 7.01756C30.2148 7.98969 30.4667 9.04579 30.4972 10.1197C30.5278 11.1937 30.3363 12.2624 29.9349 13.259C29.5334 14.2555 28.9305 15.1585 28.164 15.9114",
    stroke: "#384466",
    strokeWidth: 3.12277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8fbc3297097b099bfa30fb46458b71af.svg";
export { ForwardRef as ReactComponent };